import React, { useState } from 'react';
import { Button, Card, Space, Alert, message } from 'antd';
import { FileTextOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import SurveyLinkManagementModal from './SurveyLinkManagementModal';

const HealthSurveyButton = ({ patient }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Check if user has required role (Nursing or Administrator)
  const hasRequiredRole = user && ['Nursing', 'Admin'].includes(user.role);

  if (!hasRequiredRole) {
    return (
      <Card
        title={
          <Space>
            <LockOutlined />
            {t('healthSurvey.title')}
          </Space>
        }
        style={{ marginBottom: 16 }}
      >
        <Alert
          message={t('healthSurvey.insufficientPermissions')}
          description={t('healthSurvey.permissionMessage', { role: user?.role || 'Unknown' })}
          type="warning"
          showIcon
        />
      </Card>
    );
  }

  const handleManageSurveyLinks = () => {
    if (!patient?._id) {
      message.error('Patient information is not available');
      return;
    }
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleLinkGenerated = (linkData) => {
    message.success(t('healthSurvey.linkGenerated'));
    // Modal will handle the link display and management
  };

  return (
    <>
      <Card
        title={
          <Space>
            <FileTextOutlined />
            {t('healthSurvey.title')}
          </Space>
        }
        style={{ marginBottom: 16 }}
      >
        <div style={{ marginBottom: 12 }}>
          <p style={{ margin: 0, color: '#666' }}>
            {t('healthSurvey.linkDescription')}
          </p>
        </div>

        <Button
          type="primary"
          icon={<FileTextOutlined />}
          onClick={handleManageSurveyLinks}
          size="large"
        >
          {t('healthSurvey.manageSurveyLinks')}
        </Button>
      </Card>

      <SurveyLinkManagementModal
        visible={isModalVisible}
        patient={patient}
        onClose={handleModalClose}
        onLinkGenerated={handleLinkGenerated}
      />
    </>
  );
};

export default HealthSurveyButton;
